import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowItWorksSection from "@/components/HowItWorksSection";


import AllFeaturesSection from "@/components/AllFeaturesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import TrustedSection from "@/components/TrustedSection";
import GulfConstructionSection from "@/components/GulfConstructionSection";
import LazyOnVisible from "@/components/LazyOnVisible";


import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const PricingPreviewSection = lazy(() => import("@/components/PricingPreviewSection"));

const Index = () => {
  return (
    <div className="homepage-shell min-h-screen">
      <Header />
      <HeroSection />
      <HowItWorksSection descriptorOnly />
      <AllFeaturesSection />
      <LazyOnVisible>
        <Suspense fallback={null}>
          <PricingPreviewSection />
        </Suspense>
      </LazyOnVisible>
      <TestimonialsSection />
      <GulfConstructionSection />
      <TrustedSection />
      <FAQSection emitJsonLd />
      
      
      
      
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
